module.exports = __webpack_public_path__ + "img/insta.f32c9cef.svg";